import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { AppBar, Toolbar, Typography } from '@material-ui/core'
import { showSideMenu, setShowMobileMenu } from 'ducks/app'
import { useMsal } from '@azure/msal-react'
import { logout } from 'ducks/authen'
import { HeaderContainer } from './styled'
import Img from 'react-image'
import { Icon, Confirm, Button } from 'semantic-ui-react'
import { getActiveAnnouncements } from 'ducks/system'

import imgLogo from 'assets/images/DTGO_Logo_mini.png'

const Header = (props) => {
  const { history, logout, showMobileMenu, setShowMobileMenu, listActiveAnnouncements } = props
  const { instance, accounts } = useMsal()

  useEffect(() => {
    if (listActiveAnnouncements.loading === false) {
      props.getActiveAnnouncements()
    }
  }, [])

  const [showConfirmLogout, setShowConfirmLogout] = useState(false)

  function logoutClick(){
    setShowConfirmLogout(false)
    logout(history)
    handleLogout('redirect')
    localStorage.removeItem('accessToken')
  }

  const handleLogout = (logoutType) => {
    if (logoutType === 'popup') {
      instance.logoutPopup({
        postLogoutRedirectUri: '/',
        mainWindowRedirectUri: '/',
      })
    } else {
      instance.logoutRedirect({
        postLogoutRedirectUri: '/',
      })
    }
  }

  const announcement = () => {
    const listAnnouncement = listActiveAnnouncements.data.filter(a => a.buyer === true) || []

    if (listAnnouncement.length > 0) {
      return listAnnouncement[0].message || null
    }
    return null
  }

  return (
    <AppBar position='static' className='applicationAppBar'>
      <Toolbar>
        <HeaderContainer>
          <div className='menuBtn'>
            <Button icon onClick={() => setShowMobileMenu(!showMobileMenu)} style={{ background: 'white' }} >
              <Icon name='bars' />
            </Button>
          </div>
          <div className='applicationName'>
            <Img className='logo' src={imgLogo} style={{width:'2.5rem'}} />
            <div className='paddingLogo' />
            <Typography variant='h6' color='inherit'>
              {process.env.REACT_APP_NAME}
            </Typography>
          </div>
          {
            announcement() ? 
              <div className='announcement'>
                <div className='messageContent'>
                  <Icon name='bullhorn' styled={{ marginRight: '5px' }} />
                  {announcement()}
                </div>
              </div> : null
          }
          <div className='user'>
            <div className='userFullName'>
            {(accounts && accounts[0] && accounts[0].name) ? accounts[0].name : 
              (accounts && accounts[0] && accounts[0].username) ? accounts[0].username : '' }
            </div>
            <Icon style={{marginLeft:'1rem'}} circular link name='log out' onClick={()=>setShowConfirmLogout(true)}/>
          </div>
          <Confirm
            size='mini'
            open={showConfirmLogout}
            onCancel={()=>setShowConfirmLogout(false)}
            onConfirm={()=>logoutClick()}
          />
        </HeaderContainer>
      </Toolbar>
    </AppBar>
  )
}

const mapStateToProps = (state) => ({
  showMenu: state.app.showSideMenu,
  user: state.authen.user,
  showMobileMenu: state.app.showMobileMenu,
  listActiveAnnouncements: state.system.listActiveAnnouncements,
})

const mapDispatchToProps = {
  showSideMenu,
  logout,
  setShowMobileMenu,
  getActiveAnnouncements
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)